import React from 'react';
import FavoritesGallery from '../components/favorites/FavoritesGallery';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

const FavoritesPage: React.FC = () => {
  const { user, status } = useAuth();

  // If not logged in, redirect to login
  if (status !== 'loading' && !user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div>
      <FavoritesGallery />
    </div>
  );
};

export default FavoritesPage;